var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 7.57432L6.16399 13.7501L18 1.92576L16.3007 0.25L6.16399 10.375L1.67572 5.88676L0 7.57432Z","fill":"white"}));
}

Check.defaultProps = {"width":"18","height":"14","viewBox":"0 0 18 14","fill":"none"};

module.exports = Check;

Check.default = Check;
